import { render, staticRenderFns } from "./editFlow.vue?vue&type=template&id=3488bda4"
import script from "./editFlow.vue?vue&type=script&lang=js"
export * from "./editFlow.vue?vue&type=script&lang=js"
import style0 from "./editFlow.vue?vue&type=style&index=0&id=3488bda4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports